module.exports = __webpack_public_path__ + "static/media/sudoku.19fcfe1b.png";